import extend from 'lodash/extend';

module.exports = extend(
    // The new stuff from other scenes
    // require('./partials/dadPump'),
    // require('./partials/manPump'),
    require('./partials/baldGuyPump'),
    require('./partials/guillotine'),

    require('./partials/treadmill'),
    require('./partials/blobsTreadmill'),

    require('./partials/pipeFlow'),
    require('./partials/bucketFullFrame'),

    require('./partials/slotMachine'),
    require('./partials/blob'),
    require('./general/tiles'),
    // require('./general/faces'),

    // require('./partials/pipes'),
    // require('./partials/torchGuyTitle'),
    // require('./partials/title'),
    // require('./partials/endFrame'),
    // require('./partials/slideshow'),
    // require('./titles/titrisation'),
    // require('./partials/startFrame'),
    // require('./partials/banker'),
    {

    // pipesTitle: {
    //     texture: '/img/scenes/titrisation/pipes.png',
    //     scale: {
    //         x: '100%'
    //     }
    // },

    // titrisationTitleFr: {
    //     texture: 'sprite:/img/partials/scene-selector.json,scene-selector-sprite/titrisation-title-fr.png'
    // },
    //
    // titrisationTitle: {
    //     texture: 'sprite:/img/partials/scene-selector.json,scene-selector-sprite/titrisation-title-fr.png'
    // }

});



// WEBPACK FOOTER //
// ./js/objects/titrisation.js